import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { UserStateService } from './app/core/service/user-state.service';
import { Subject, takeUntil } from 'rxjs';
import { RouterModule } from '@angular/router';
import { PrimeNG} from 'primeng/config'
import { SpinnerService } from './app/shared/spinner/spinner.service';
import { SpinnerComponent } from './app/shared/spinner/spinner.component';

@Component({
    selector: 'app-root',
    standalone: true,
  imports: [RouterModule, SpinnerComponent, AsyncPipe],
  template: `
  @if(spinner$ | async){<app-spinner />}
  <router-outlet />
  `
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly primeConfig = inject(PrimeNG);

  private readonly spinner = inject(SpinnerService);
  private readonly userState = inject(UserStateService);
  spinner$ = this.spinner.isLoading;
  private destroy$ = new Subject<void>();
  ngOnInit() {
    // Diferir una vuelta para evitar NG0100 al activar spinner durante el primer ciclo de CD
    setTimeout(() => {
      void this.userState.hydrateFromToken();
    }, 0);
    //this.primeConfig.ripple = true;
    //this.primeConfig.setTranslation(es);

    /** @description Nos suscribimos a los cambios del spinner para mostrarlo o no */
  // Eliminado manejo manual; se usa async pipe.
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
